import React from 'react';

const isReactElement = (
  reactChild: React.ReactNode,
): reactChild is React.ReactElement<
  unknown,
  React.JSXElementConstructor<unknown> & { displayName: string }
> => typeof reactChild !== 'string' || typeof reactChild !== 'number';

export const extractChildrenOfName = (
  children: React.ReactNode,
  displayName: string,
) => {
  const allChildren = React.Children.toArray(children);
  return allChildren
    .filter(
      (child): child is React.ReactElement =>
        isReactElement(child) && child.type.displayName === displayName,
    )
    .map((element) => element.props.children);
};
